const PACKAGE_LINKS = {
  IMAGES_SLIDER:
    'https://cdn.jsdelivr.net/gh/dragos199993/js-cloudimage-360-view@master/build/js-cloudimage-360-view.min.js',
};

export default PACKAGE_LINKS;
